export default "__VITE_ASSET__CpmdBy$w__"